/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";
import { SDKCore } from "../core.js";
import { SDKOptions } from "../lib/config.js";
import type { ConsoleLogger } from "./console-logger.js";
import { createRegisterPrompt } from "./prompts.js";
import {
  createRegisterResource,
  createRegisterResourceTemplate,
} from "./resources.js";
import { MCPScope } from "./scopes.js";
import { createRegisterTool } from "./tools.js";
import { tool$agentConnectorsActivateAgentConnector } from "./tools/agentConnectorsActivateAgentConnector.js";
import { tool$agentConnectorsCreateAgentConnector } from "./tools/agentConnectorsCreateAgentConnector.js";
import { tool$agentConnectorsDeleteAgentConnector } from "./tools/agentConnectorsDeleteAgentConnector.js";
import { tool$agentConnectorsGetAgentConnector } from "./tools/agentConnectorsGetAgentConnector.js";
import { tool$agentConnectorsListAgentConnectors } from "./tools/agentConnectorsListAgentConnectors.js";
import { tool$agentConnectorsSetupWhatsAppAppWebhook } from "./tools/agentConnectorsSetupWhatsAppAppWebhook.js";
import { tool$agentRunsCreateAgentRun } from "./tools/agentRunsCreateAgentRun.js";
import { tool$agentRunsDecideAgentRunMcpApproval } from "./tools/agentRunsDecideAgentRunMcpApproval.js";
import { tool$agentRunsGetAgentRun } from "./tools/agentRunsGetAgentRun.js";
import { tool$agentRunsListAgentRuns } from "./tools/agentRunsListAgentRuns.js";
import { tool$agentRunsStreamAgentRunEvents } from "./tools/agentRunsStreamAgentRunEvents.js";
import { tool$agentRunsWakeAgentRun } from "./tools/agentRunsWakeAgentRun.js";
import { tool$agentSchedulesCreateAgentSchedule } from "./tools/agentSchedulesCreateAgentSchedule.js";
import { tool$agentSchedulesDeleteAgentSchedule } from "./tools/agentSchedulesDeleteAgentSchedule.js";
import { tool$agentSchedulesGetAgentSchedule } from "./tools/agentSchedulesGetAgentSchedule.js";
import { tool$agentSchedulesListAgentSchedules } from "./tools/agentSchedulesListAgentSchedules.js";
import { tool$agentSchedulesPauseAgentSchedule } from "./tools/agentSchedulesPauseAgentSchedule.js";
import { tool$agentSchedulesResumeAgentSchedule } from "./tools/agentSchedulesResumeAgentSchedule.js";
import { tool$agentSchedulesUpdateAgentSchedule } from "./tools/agentSchedulesUpdateAgentSchedule.js";
import { tool$agentsCreateAgent } from "./tools/agentsCreateAgent.js";
import { tool$agentsDeleteAgent } from "./tools/agentsDeleteAgent.js";
import { tool$agentsGetAgent } from "./tools/agentsGetAgent.js";
import { tool$agentsListAgents } from "./tools/agentsListAgents.js";
import { tool$agentsUpdateAgent } from "./tools/agentsUpdateAgent.js";
import { tool$agentVersionsGetAgentVersion } from "./tools/agentVersionsGetAgentVersion.js";
import { tool$agentVersionsListAgentVersions } from "./tools/agentVersionsListAgentVersions.js";
import { tool$agentVersionsRollbackAgentVersion } from "./tools/agentVersionsRollbackAgentVersion.js";
import { tool$authApiKeyGetJwtFromKey } from "./tools/authApiKeyGetJwtFromKey.js";
import { tool$authApiKeysCreate } from "./tools/authApiKeysCreate.js";
import { tool$authApiKeysExchangeToken } from "./tools/authApiKeysExchangeToken.js";
import { tool$authApiKeysList } from "./tools/authApiKeysList.js";
import { tool$authApiKeysRegenerate } from "./tools/authApiKeysRegenerate.js";
import { tool$authApiKeysUpdate } from "./tools/authApiKeysUpdate.js";
import { tool$authClusterAcceptInvite } from "./tools/authClusterAcceptInvite.js";
import { tool$authClusterCreateInvite } from "./tools/authClusterCreateInvite.js";
import { tool$authClusterDeleteOrg } from "./tools/authClusterDeleteOrg.js";
import { tool$authClusterGetOrg } from "./tools/authClusterGetOrg.js";
import { tool$authClusterInviteInfo } from "./tools/authClusterInviteInfo.js";
import { tool$authClusterListInvites } from "./tools/authClusterListInvites.js";
import { tool$authClusterListOrgs } from "./tools/authClusterListOrgs.js";
import { tool$authClusterReissueOwnerKey } from "./tools/authClusterReissueOwnerKey.js";
import { tool$authClusterRevokeInvite } from "./tools/authClusterRevokeInvite.js";
import { tool$authClusterSuspendOrg } from "./tools/authClusterSuspendOrg.js";
import { tool$authClusterUnsuspendOrg } from "./tools/authClusterUnsuspendOrg.js";
import { tool$authOrgsGetQuota } from "./tools/authOrgsGetQuota.js";
import { tool$authOrgsGetRateLimit } from "./tools/authOrgsGetRateLimit.js";
import { tool$authOrgsUpdateQuota } from "./tools/authOrgsUpdateQuota.js";
import { tool$authOrgsUpdateRateLimit } from "./tools/authOrgsUpdateRateLimit.js";
import { tool$authServiceAccountsCreate } from "./tools/authServiceAccountsCreate.js";
import { tool$authServiceAccountsDelete } from "./tools/authServiceAccountsDelete.js";
import { tool$authServiceAccountsDeleteApiKey } from "./tools/authServiceAccountsDeleteApiKey.js";
import { tool$authServiceAccountsGet } from "./tools/authServiceAccountsGet.js";
import { tool$authServiceAccountsList } from "./tools/authServiceAccountsList.js";
import { tool$authServiceAccountsListApiKeys } from "./tools/authServiceAccountsListApiKeys.js";
import { tool$authServiceAccountsRegenerateApiKey } from "./tools/authServiceAccountsRegenerateApiKey.js";
import { tool$authServiceAccountsUpdateApiKey } from "./tools/authServiceAccountsUpdateApiKey.js";
import { tool$authTeamsAddMember } from "./tools/authTeamsAddMember.js";
import { tool$authTeamsCreate } from "./tools/authTeamsCreate.js";
import { tool$authTeamsDelete } from "./tools/authTeamsDelete.js";
import { tool$authTeamsGet } from "./tools/authTeamsGet.js";
import { tool$authTeamsList } from "./tools/authTeamsList.js";
import { tool$authTeamsListMembers } from "./tools/authTeamsListMembers.js";
import { tool$authTeamsRemoveMember } from "./tools/authTeamsRemoveMember.js";
import { tool$authTeamsUpdate } from "./tools/authTeamsUpdate.js";
import { tool$budgetsApiKeyEvents } from "./tools/budgetsApiKeyEvents.js";
import { tool$budgetsDeleteApiKey } from "./tools/budgetsDeleteApiKey.js";
import { tool$budgetsDeleteExternalUser } from "./tools/budgetsDeleteExternalUser.js";
import { tool$budgetsDeleteExternalUserDefault } from "./tools/budgetsDeleteExternalUserDefault.js";
import { tool$budgetsDeleteOrg } from "./tools/budgetsDeleteOrg.js";
import { tool$budgetsDeleteTeam } from "./tools/budgetsDeleteTeam.js";
import { tool$budgetsDeleteTeamDefault } from "./tools/budgetsDeleteTeamDefault.js";
import { tool$budgetsDeleteUser } from "./tools/budgetsDeleteUser.js";
import { tool$budgetsDeleteUserDefault } from "./tools/budgetsDeleteUserDefault.js";
import { tool$budgetsExternalUserDefaultEvents } from "./tools/budgetsExternalUserDefaultEvents.js";
import { tool$budgetsExternalUserEvents } from "./tools/budgetsExternalUserEvents.js";
import { tool$budgetsGetApiKey } from "./tools/budgetsGetApiKey.js";
import { tool$budgetsGetCurrency } from "./tools/budgetsGetCurrency.js";
import { tool$budgetsGetExternalUser } from "./tools/budgetsGetExternalUser.js";
import { tool$budgetsGetExternalUserDefault } from "./tools/budgetsGetExternalUserDefault.js";
import { tool$budgetsGetOrg } from "./tools/budgetsGetOrg.js";
import { tool$budgetsGetTeam } from "./tools/budgetsGetTeam.js";
import { tool$budgetsGetTeamDefault } from "./tools/budgetsGetTeamDefault.js";
import { tool$budgetsGetUser } from "./tools/budgetsGetUser.js";
import { tool$budgetsGetUserDefault } from "./tools/budgetsGetUserDefault.js";
import { tool$budgetsList } from "./tools/budgetsList.js";
import { tool$budgetsOrgEvents } from "./tools/budgetsOrgEvents.js";
import { tool$budgetsSetApiKey } from "./tools/budgetsSetApiKey.js";
import { tool$budgetsSetCurrency } from "./tools/budgetsSetCurrency.js";
import { tool$budgetsSetExternalUser } from "./tools/budgetsSetExternalUser.js";
import { tool$budgetsSetExternalUserDefault } from "./tools/budgetsSetExternalUserDefault.js";
import { tool$budgetsSetOrg } from "./tools/budgetsSetOrg.js";
import { tool$budgetsSetTeam } from "./tools/budgetsSetTeam.js";
import { tool$budgetsSetTeamDefault } from "./tools/budgetsSetTeamDefault.js";
import { tool$budgetsSetUser } from "./tools/budgetsSetUser.js";
import { tool$budgetsSetUserDefault } from "./tools/budgetsSetUserDefault.js";
import { tool$budgetsTeamDefaultEvents } from "./tools/budgetsTeamDefaultEvents.js";
import { tool$budgetsTeamEvents } from "./tools/budgetsTeamEvents.js";
import { tool$budgetsUserDefaultEvents } from "./tools/budgetsUserDefaultEvents.js";
import { tool$budgetsUserEvents } from "./tools/budgetsUserEvents.js";
import { tool$computeCatalogCreateComputeQuote } from "./tools/computeCatalogCreateComputeQuote.js";
import { tool$computeCatalogGetAccelerator } from "./tools/computeCatalogGetAccelerator.js";
import { tool$computeCatalogListAccelerators } from "./tools/computeCatalogListAccelerators.js";
import { tool$computeCatalogListComputeOffers } from "./tools/computeCatalogListComputeOffers.js";
import { tool$computeCatalogListComputeProviders } from "./tools/computeCatalogListComputeProviders.js";
import { tool$computeJobsCreateJob } from "./tools/computeJobsCreateJob.js";
import { tool$computeJobsGetJob } from "./tools/computeJobsGetJob.js";
import { tool$computeJobsListJobEvents } from "./tools/computeJobsListJobEvents.js";
import { tool$computeJobsListJobInstances } from "./tools/computeJobsListJobInstances.js";
import { tool$computeJobsListJobLogs } from "./tools/computeJobsListJobLogs.js";
import { tool$computeJobsListJobs } from "./tools/computeJobsListJobs.js";
import { tool$computeJobsTerminateJob } from "./tools/computeJobsTerminateJob.js";
import { tool$computeSecretsCreateComputeSecret } from "./tools/computeSecretsCreateComputeSecret.js";
import { tool$computeSecretsDeleteComputeSecret } from "./tools/computeSecretsDeleteComputeSecret.js";
import { tool$computeSecretsGetComputeSecret } from "./tools/computeSecretsGetComputeSecret.js";
import { tool$computeSecretsListComputeSecrets } from "./tools/computeSecretsListComputeSecrets.js";
import { tool$computeServicesCreateService } from "./tools/computeServicesCreateService.js";
import { tool$computeServicesGetService } from "./tools/computeServicesGetService.js";
import { tool$computeServicesListServiceEvents } from "./tools/computeServicesListServiceEvents.js";
import { tool$computeServicesListServiceInstances } from "./tools/computeServicesListServiceInstances.js";
import { tool$computeServicesListServiceLogs } from "./tools/computeServicesListServiceLogs.js";
import { tool$computeServicesListServices } from "./tools/computeServicesListServices.js";
import { tool$computeServicesTerminateService } from "./tools/computeServicesTerminateService.js";
import { tool$computeTenantsGetComputeTenant } from "./tools/computeTenantsGetComputeTenant.js";
import { tool$computeTenantsListComputeTenants } from "./tools/computeTenantsListComputeTenants.js";
import { tool$computeTenantsPutComputeTenant } from "./tools/computeTenantsPutComputeTenant.js";
import { tool$computeUsageGetComputeUsage } from "./tools/computeUsageGetComputeUsage.js";
import { tool$guardrailsDeleteGuardrails } from "./tools/guardrailsDeleteGuardrails.js";
import { tool$guardrailsGetGuardrails } from "./tools/guardrailsGetGuardrails.js";
import { tool$guardrailsListGuardrailsPolicies } from "./tools/guardrailsListGuardrailsPolicies.js";
import { tool$guardrailsTestGuardrails } from "./tools/guardrailsTestGuardrails.js";
import { tool$guardrailsUpdateGuardrails } from "./tools/guardrailsUpdateGuardrails.js";
import { tool$llmBatchesCancel } from "./tools/llmBatchesCancel.js";
import { tool$llmBatchesCreate } from "./tools/llmBatchesCreate.js";
import { tool$llmBatchesGet } from "./tools/llmBatchesGet.js";
import { tool$llmBatchesList } from "./tools/llmBatchesList.js";
import { tool$llmChatCreateChat } from "./tools/llmChatCreateChat.js";
import { tool$llmChatStream } from "./tools/llmChatStream.js";
import { tool$llmClassifyClassify } from "./tools/llmClassifyClassify.js";
import { tool$llmConversationsCreate } from "./tools/llmConversationsCreate.js";
import { tool$llmConversationsCreateItems } from "./tools/llmConversationsCreateItems.js";
import { tool$llmConversationsDelete } from "./tools/llmConversationsDelete.js";
import { tool$llmConversationsDeleteItem } from "./tools/llmConversationsDeleteItem.js";
import { tool$llmConversationsDeleteItems } from "./tools/llmConversationsDeleteItems.js";
import { tool$llmConversationsGet } from "./tools/llmConversationsGet.js";
import { tool$llmConversationsGetItem } from "./tools/llmConversationsGetItem.js";
import { tool$llmConversationsList } from "./tools/llmConversationsList.js";
import { tool$llmConversationsListItems } from "./tools/llmConversationsListItems.js";
import { tool$llmConversationsUpdate } from "./tools/llmConversationsUpdate.js";
import { tool$llmEmbeddingsEmbed } from "./tools/llmEmbeddingsEmbed.js";
import { tool$llmEmbeddingsListModels } from "./tools/llmEmbeddingsListModels.js";
import { tool$llmEvalsCancelRun } from "./tools/llmEvalsCancelRun.js";
import { tool$llmEvalsCreateRun } from "./tools/llmEvalsCreateRun.js";
import { tool$llmEvalsCreateSchedule } from "./tools/llmEvalsCreateSchedule.js";
import { tool$llmEvalsCreateSuite } from "./tools/llmEvalsCreateSuite.js";
import { tool$llmEvalsCreateSuiteVersion } from "./tools/llmEvalsCreateSuiteVersion.js";
import { tool$llmEvalsDeleteRun } from "./tools/llmEvalsDeleteRun.js";
import { tool$llmEvalsDeleteSchedule } from "./tools/llmEvalsDeleteSchedule.js";
import { tool$llmEvalsDeleteSuite } from "./tools/llmEvalsDeleteSuite.js";
import { tool$llmEvalsGetArtifacts } from "./tools/llmEvalsGetArtifacts.js";
import { tool$llmEvalsGetRun } from "./tools/llmEvalsGetRun.js";
import { tool$llmEvalsGetSampleAudio } from "./tools/llmEvalsGetSampleAudio.js";
import { tool$llmEvalsGetSchedule } from "./tools/llmEvalsGetSchedule.js";
import { tool$llmEvalsGetSuite } from "./tools/llmEvalsGetSuite.js";
import { tool$llmEvalsGetSuiteVersion } from "./tools/llmEvalsGetSuiteVersion.js";
import { tool$llmEvalsImportHistoricalResults } from "./tools/llmEvalsImportHistoricalResults.js";
import { tool$llmEvalsListRuns } from "./tools/llmEvalsListRuns.js";
import { tool$llmEvalsListSamples } from "./tools/llmEvalsListSamples.js";
import { tool$llmEvalsListScheduleRuns } from "./tools/llmEvalsListScheduleRuns.js";
import { tool$llmEvalsListSchedules } from "./tools/llmEvalsListSchedules.js";
import { tool$llmEvalsListSuiteLeaderboardRuns } from "./tools/llmEvalsListSuiteLeaderboardRuns.js";
import { tool$llmEvalsListSuites } from "./tools/llmEvalsListSuites.js";
import { tool$llmEvalsListSuiteVersions } from "./tools/llmEvalsListSuiteVersions.js";
import { tool$llmEvalsRerunFailedSamples } from "./tools/llmEvalsRerunFailedSamples.js";
import { tool$llmEvalsRetryFailedRun } from "./tools/llmEvalsRetryFailedRun.js";
import { tool$llmEvalsTriggerSchedule } from "./tools/llmEvalsTriggerSchedule.js";
import { tool$llmEvalsUpdateSchedule } from "./tools/llmEvalsUpdateSchedule.js";
import { tool$llmExtractCreateSchema } from "./tools/llmExtractCreateSchema.js";
import { tool$llmExtractDeleteSchema } from "./tools/llmExtractDeleteSchema.js";
import { tool$llmExtractExtract } from "./tools/llmExtractExtract.js";
import { tool$llmExtractExtractWithSchema } from "./tools/llmExtractExtractWithSchema.js";
import { tool$llmExtractGetSchema } from "./tools/llmExtractGetSchema.js";
import { tool$llmExtractUpdateSchema } from "./tools/llmExtractUpdateSchema.js";
import { tool$llmFeedbackBatchGetCompletionFeedback } from "./tools/llmFeedbackBatchGetCompletionFeedback.js";
import { tool$llmFeedbackBatchGetResponseFeedback } from "./tools/llmFeedbackBatchGetResponseFeedback.js";
import { tool$llmFeedbackCreateCompletionFeedback } from "./tools/llmFeedbackCreateCompletionFeedback.js";
import { tool$llmFeedbackCreateResponseFeedback } from "./tools/llmFeedbackCreateResponseFeedback.js";
import { tool$llmFeedbackExportCompletionFeedback } from "./tools/llmFeedbackExportCompletionFeedback.js";
import { tool$llmFeedbackExportResponseFeedback } from "./tools/llmFeedbackExportResponseFeedback.js";
import { tool$llmFeedbackGetCompletionFeedback } from "./tools/llmFeedbackGetCompletionFeedback.js";
import { tool$llmFeedbackGetExportStatus } from "./tools/llmFeedbackGetExportStatus.js";
import { tool$llmFeedbackGetResponseFeedback } from "./tools/llmFeedbackGetResponseFeedback.js";
import { tool$llmFeedbackListCompletionFeedback } from "./tools/llmFeedbackListCompletionFeedback.js";
import { tool$llmFeedbackListResponseFeedback } from "./tools/llmFeedbackListResponseFeedback.js";
import { tool$llmFeedbackStartExport } from "./tools/llmFeedbackStartExport.js";
import { tool$llmFeedbackUpdateCompletionFeedback } from "./tools/llmFeedbackUpdateCompletionFeedback.js";
import { tool$llmFeedbackUpdateResponseFeedback } from "./tools/llmFeedbackUpdateResponseFeedback.js";
import { tool$llmFilesContent } from "./tools/llmFilesContent.js";
import { tool$llmFilesDelete } from "./tools/llmFilesDelete.js";
import { tool$llmFilesGet } from "./tools/llmFilesGet.js";
import { tool$llmFilesList } from "./tools/llmFilesList.js";
import { tool$llmFilesUpload } from "./tools/llmFilesUpload.js";
import { tool$llmFineTuningCancel } from "./tools/llmFineTuningCancel.js";
import { tool$llmFineTuningCreate } from "./tools/llmFineTuningCreate.js";
import { tool$llmFineTuningList } from "./tools/llmFineTuningList.js";
import { tool$llmFineTuningListCheckpoints } from "./tools/llmFineTuningListCheckpoints.js";
import { tool$llmFineTuningListEvents } from "./tools/llmFineTuningListEvents.js";
import { tool$llmFineTuningPause } from "./tools/llmFineTuningPause.js";
import { tool$llmFineTuningResume } from "./tools/llmFineTuningResume.js";
import { tool$llmFineTuningRetrieve } from "./tools/llmFineTuningRetrieve.js";
import { tool$llmImagesCreate } from "./tools/llmImagesCreate.js";
import { tool$llmMcpVaultCreateCredential } from "./tools/llmMcpVaultCreateCredential.js";
import { tool$llmMcpVaultCreateServer } from "./tools/llmMcpVaultCreateServer.js";
import { tool$llmMcpVaultDeleteCredential } from "./tools/llmMcpVaultDeleteCredential.js";
import { tool$llmMcpVaultDeleteServer } from "./tools/llmMcpVaultDeleteServer.js";
import { tool$llmMcpVaultGetServer } from "./tools/llmMcpVaultGetServer.js";
import { tool$llmMcpVaultListCredentials } from "./tools/llmMcpVaultListCredentials.js";
import { tool$llmMcpVaultListServers } from "./tools/llmMcpVaultListServers.js";
import { tool$llmMcpVaultTestServer } from "./tools/llmMcpVaultTestServer.js";
import { tool$llmMcpVaultUpdateServer } from "./tools/llmMcpVaultUpdateServer.js";
import { tool$llmMemoryStoresCreate } from "./tools/llmMemoryStoresCreate.js";
import { tool$llmMemoryStoresCreateEntry } from "./tools/llmMemoryStoresCreateEntry.js";
import { tool$llmMemoryStoresDelete } from "./tools/llmMemoryStoresDelete.js";
import { tool$llmMemoryStoresDeleteEntry } from "./tools/llmMemoryStoresDeleteEntry.js";
import { tool$llmMemoryStoresGet } from "./tools/llmMemoryStoresGet.js";
import { tool$llmMemoryStoresGetEntry } from "./tools/llmMemoryStoresGetEntry.js";
import { tool$llmMemoryStoresList } from "./tools/llmMemoryStoresList.js";
import { tool$llmMemoryStoresListEntries } from "./tools/llmMemoryStoresListEntries.js";
import { tool$llmMemoryStoresUpdate } from "./tools/llmMemoryStoresUpdate.js";
import { tool$llmMemoryStoresUpdateEntry } from "./tools/llmMemoryStoresUpdateEntry.js";
import { tool$llmModelsActivateRegistryEntry } from "./tools/llmModelsActivateRegistryEntry.js";
import { tool$llmModelsAddCatalogEntry } from "./tools/llmModelsAddCatalogEntry.js";
import { tool$llmModelsAddCatalogOrgAccess } from "./tools/llmModelsAddCatalogOrgAccess.js";
import { tool$llmModelsCheckCatalogHealth } from "./tools/llmModelsCheckCatalogHealth.js";
import { tool$llmModelsClearClusterPrice } from "./tools/llmModelsClearClusterPrice.js";
import { tool$llmModelsClearOrgPrice } from "./tools/llmModelsClearOrgPrice.js";
import { tool$llmModelsDeactivateRegistryEntry } from "./tools/llmModelsDeactivateRegistryEntry.js";
import { tool$llmModelsDeleteCatalogEntry } from "./tools/llmModelsDeleteCatalogEntry.js";
import { tool$llmModelsDeleteOrgAutoModel } from "./tools/llmModelsDeleteOrgAutoModel.js";
import { tool$llmModelsGet } from "./tools/llmModelsGet.js";
import { tool$llmModelsGetClusterCurrency } from "./tools/llmModelsGetClusterCurrency.js";
import { tool$llmModelsList } from "./tools/llmModelsList.js";
import { tool$llmModelsListCatalog } from "./tools/llmModelsListCatalog.js";
import { tool$llmModelsListCatalogModelAccess } from "./tools/llmModelsListCatalogModelAccess.js";
import { tool$llmModelsListCatalogOrgAccess } from "./tools/llmModelsListCatalogOrgAccess.js";
import { tool$llmModelsListClusterPrices } from "./tools/llmModelsListClusterPrices.js";
import { tool$llmModelsListEffectivePrices } from "./tools/llmModelsListEffectivePrices.js";
import { tool$llmModelsListOrgAutoModels } from "./tools/llmModelsListOrgAutoModels.js";
import { tool$llmModelsListOrgPrices } from "./tools/llmModelsListOrgPrices.js";
import { tool$llmModelsListRegistry } from "./tools/llmModelsListRegistry.js";
import { tool$llmModelsPutOrgAutoModel } from "./tools/llmModelsPutOrgAutoModel.js";
import { tool$llmModelsReplaceCatalogOrgAccess } from "./tools/llmModelsReplaceCatalogOrgAccess.js";
import { tool$llmModelsSetClusterCurrency } from "./tools/llmModelsSetClusterCurrency.js";
import { tool$llmModelsSetClusterPrice } from "./tools/llmModelsSetClusterPrice.js";
import { tool$llmModelsSetOrgPrice } from "./tools/llmModelsSetOrgPrice.js";
import { tool$llmModelsUpdateCatalogEntry } from "./tools/llmModelsUpdateCatalogEntry.js";
import { tool$llmPromptsCreate } from "./tools/llmPromptsCreate.js";
import { tool$llmPromptsCreateVersion } from "./tools/llmPromptsCreateVersion.js";
import { tool$llmPromptsDelete } from "./tools/llmPromptsDelete.js";
import { tool$llmPromptsGet } from "./tools/llmPromptsGet.js";
import { tool$llmPromptsGetVersion } from "./tools/llmPromptsGetVersion.js";
import { tool$llmPromptsList } from "./tools/llmPromptsList.js";
import { tool$llmPromptsListVersions } from "./tools/llmPromptsListVersions.js";
import { tool$llmPromptsRollback } from "./tools/llmPromptsRollback.js";
import { tool$llmPromptsUpdate } from "./tools/llmPromptsUpdate.js";
import { tool$llmResponsesCancel } from "./tools/llmResponsesCancel.js";
import { tool$llmResponsesCompact } from "./tools/llmResponsesCompact.js";
import { tool$llmResponsesCreate } from "./tools/llmResponsesCreate.js";
import { tool$llmResponsesDelete } from "./tools/llmResponsesDelete.js";
import { tool$llmResponsesGet } from "./tools/llmResponsesGet.js";
import { tool$llmResponsesList } from "./tools/llmResponsesList.js";
import { tool$llmResponsesListInputItems } from "./tools/llmResponsesListInputItems.js";
import { tool$llmResponsesUpdate } from "./tools/llmResponsesUpdate.js";
import { tool$llmResponsesWake } from "./tools/llmResponsesWake.js";
import { tool$llmSkillsContent } from "./tools/llmSkillsContent.js";
import { tool$llmSkillsCreate } from "./tools/llmSkillsCreate.js";
import { tool$llmSkillsCreateVersion } from "./tools/llmSkillsCreateVersion.js";
import { tool$llmSkillsDelete } from "./tools/llmSkillsDelete.js";
import { tool$llmSkillsDeleteVersion } from "./tools/llmSkillsDeleteVersion.js";
import { tool$llmSkillsGet } from "./tools/llmSkillsGet.js";
import { tool$llmSkillsGetVersion } from "./tools/llmSkillsGetVersion.js";
import { tool$llmSkillsList } from "./tools/llmSkillsList.js";
import { tool$llmSkillsListPreconfigured } from "./tools/llmSkillsListPreconfigured.js";
import { tool$llmSkillsListVersions } from "./tools/llmSkillsListVersions.js";
import { tool$llmSkillsUpdate } from "./tools/llmSkillsUpdate.js";
import { tool$llmSkillsVersionContent } from "./tools/llmSkillsVersionContent.js";
import { tool$llmSpeechDeleteTranscriptionHistory } from "./tools/llmSpeechDeleteTranscriptionHistory.js";
import { tool$llmSpeechDeleteTtsHistory } from "./tools/llmSpeechDeleteTtsHistory.js";
import { tool$llmSpeechGetTranscriptionHistory } from "./tools/llmSpeechGetTranscriptionHistory.js";
import { tool$llmSpeechGetTranscriptionHistoryContent } from "./tools/llmSpeechGetTranscriptionHistoryContent.js";
import { tool$llmSpeechGetTtsHistory } from "./tools/llmSpeechGetTtsHistory.js";
import { tool$llmSpeechGetTtsHistoryContent } from "./tools/llmSpeechGetTtsHistoryContent.js";
import { tool$llmSpeechListTranscriptionHistory } from "./tools/llmSpeechListTranscriptionHistory.js";
import { tool$llmSpeechListTtsHistory } from "./tools/llmSpeechListTtsHistory.js";
import { tool$llmSpeechLivekitToken } from "./tools/llmSpeechLivekitToken.js";
import { tool$llmSpeechSpeak } from "./tools/llmSpeechSpeak.js";
import { tool$llmSpeechSpeakStreaming } from "./tools/llmSpeechSpeakStreaming.js";
import { tool$llmSpeechTranscribe } from "./tools/llmSpeechTranscribe.js";
import { tool$llmUsageClassify } from "./tools/llmUsageClassify.js";
import { tool$llmUsageCompletions } from "./tools/llmUsageCompletions.js";
import { tool$llmUsageConversations } from "./tools/llmUsageConversations.js";
import { tool$llmUsageCosts } from "./tools/llmUsageCosts.js";
import { tool$llmUsageEmbeddings } from "./tools/llmUsageEmbeddings.js";
import { tool$llmUsageExtract } from "./tools/llmUsageExtract.js";
import { tool$llmUsageFiles } from "./tools/llmUsageFiles.js";
import { tool$llmUsageResponses } from "./tools/llmUsageResponses.js";
import { tool$llmUsageVectorStores } from "./tools/llmUsageVectorStores.js";
import { tool$llmVectorStoresCancelFileBatch } from "./tools/llmVectorStoresCancelFileBatch.js";
import { tool$llmVectorStoresCreate } from "./tools/llmVectorStoresCreate.js";
import { tool$llmVectorStoresCreateFile } from "./tools/llmVectorStoresCreateFile.js";
import { tool$llmVectorStoresCreateFileBatch } from "./tools/llmVectorStoresCreateFileBatch.js";
import { tool$llmVectorStoresDelete } from "./tools/llmVectorStoresDelete.js";
import { tool$llmVectorStoresDeleteFile } from "./tools/llmVectorStoresDeleteFile.js";
import { tool$llmVectorStoresGet } from "./tools/llmVectorStoresGet.js";
import { tool$llmVectorStoresGetFile } from "./tools/llmVectorStoresGetFile.js";
import { tool$llmVectorStoresGetFileBatch } from "./tools/llmVectorStoresGetFileBatch.js";
import { tool$llmVectorStoresGetFileContent } from "./tools/llmVectorStoresGetFileContent.js";
import { tool$llmVectorStoresList } from "./tools/llmVectorStoresList.js";
import { tool$llmVectorStoresListFiles } from "./tools/llmVectorStoresListFiles.js";
import { tool$llmVectorStoresListFilesInBatch } from "./tools/llmVectorStoresListFilesInBatch.js";
import { tool$llmVectorStoresSearch } from "./tools/llmVectorStoresSearch.js";
import { tool$llmVectorStoresUpdate } from "./tools/llmVectorStoresUpdate.js";
import { tool$llmVectorStoresUpdateFile } from "./tools/llmVectorStoresUpdateFile.js";
import { tool$permissionsLlmCheck } from "./tools/permissionsLlmCheck.js";
import { tool$permissionsLlmGrant } from "./tools/permissionsLlmGrant.js";
import { tool$permissionsLlmRevoke } from "./tools/permissionsLlmRevoke.js";
import { tool$reposCreate } from "./tools/reposCreate.js";
import { tool$reposDelete } from "./tools/reposDelete.js";
import { tool$reposGet } from "./tools/reposGet.js";
import { tool$reposList } from "./tools/reposList.js";
import { tool$reposUpdate } from "./tools/reposUpdate.js";
import { tool$sandboxCreate } from "./tools/sandboxCreate.js";
import { tool$sandboxDownloadArchive } from "./tools/sandboxDownloadArchive.js";
import { tool$sandboxDownloadFile } from "./tools/sandboxDownloadFile.js";
import { tool$sandboxGet } from "./tools/sandboxGet.js";
import { tool$sandboxGetBrowserUrl } from "./tools/sandboxGetBrowserUrl.js";
import { tool$sandboxGetPricing } from "./tools/sandboxGetPricing.js";
import { tool$sandboxGetWorkspace } from "./tools/sandboxGetWorkspace.js";
import { tool$sandboxList } from "./tools/sandboxList.js";
import { tool$sandboxProxyBrowserPortRequest } from "./tools/sandboxProxyBrowserPortRequest.js";
import { tool$sandboxRunCode } from "./tools/sandboxRunCode.js";
import { tool$sandboxRunCommand } from "./tools/sandboxRunCommand.js";
import { tool$sandboxSetPricing } from "./tools/sandboxSetPricing.js";
import { tool$sandboxTerminate } from "./tools/sandboxTerminate.js";
import { tool$sandboxUploadArchive } from "./tools/sandboxUploadArchive.js";
import { tool$sandboxUploadFile } from "./tools/sandboxUploadFile.js";
import { tool$schema3OtherConnectApiV1SandboxGithubOauthConnectionsPost } from "./tools/schema3OtherConnectApiV1SandboxGithubOauthConnectionsPost.js";
import { tool$schema3OtherCreateIntentApiV1SandboxGithubOauthIntentsPost } from "./tools/schema3OtherCreateIntentApiV1SandboxGithubOauthIntentsPost.js";
import { tool$schema3OtherDisconnectApiV1SandboxGithubOauthConnectionsDelete } from "./tools/schema3OtherDisconnectApiV1SandboxGithubOauthConnectionsDelete.js";
import { tool$schema3OtherGetConnectionApiV1SandboxGithubOauthConnectionsGet } from "./tools/schema3OtherGetConnectionApiV1SandboxGithubOauthConnectionsGet.js";
import { tool$schema3OtherListRepositoriesApiV1SandboxGithubRepositoriesGet } from "./tools/schema3OtherListRepositoriesApiV1SandboxGithubRepositoriesGet.js";
import { tool$schema3OtherReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePost } from "./tools/schema3OtherReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePost.js";
import { tool$schema3OtherRefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPost } from "./tools/schema3OtherRefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPost.js";
import { tool$schema3OtherResolveReferenceApiV1SandboxGithubRepositoriesResolvePost } from "./tools/schema3OtherResolveReferenceApiV1SandboxGithubRepositoriesResolvePost.js";
import { tool$usageCosts } from "./tools/usageCosts.js";
import { tool$usageSandbox } from "./tools/usageSandbox.js";

export function createMCPServer(deps: {
  logger: ConsoleLogger;
  allowedTools?: string[] | undefined;
  scopes?: MCPScope[] | undefined;
  serverURL?: string | undefined;
  bearerAuth?: SDKOptions["bearerAuth"] | undefined;
  serverIdx?: SDKOptions["serverIdx"] | undefined;
}) {
  const server = new McpServer({
    name: "SDK",
    version: "0.53.32",
  });

  const client = new SDKCore({
    bearerAuth: deps.bearerAuth,
    serverURL: deps.serverURL,
    serverIdx: deps.serverIdx,
  });

  const scopes = new Set(deps.scopes);

  const allowedTools = deps.allowedTools && new Set(deps.allowedTools);
  const tool = createRegisterTool(
    deps.logger,
    server,
    client,
    scopes,
    allowedTools,
  );
  const resource = createRegisterResource(deps.logger, server, client, scopes);
  const resourceTemplate = createRegisterResourceTemplate(
    deps.logger,
    server,
    client,
    scopes,
  );
  const prompt = createRegisterPrompt(deps.logger, server, client, scopes);
  const register = { tool, resource, resourceTemplate, prompt };
  void register; // suppress unused warnings

  tool(tool$guardrailsGetGuardrails);
  tool(tool$guardrailsUpdateGuardrails);
  tool(tool$guardrailsDeleteGuardrails);
  tool(tool$guardrailsListGuardrailsPolicies);
  tool(tool$guardrailsTestGuardrails);
  tool(tool$schema3OtherCreateIntentApiV1SandboxGithubOauthIntentsPost);
  tool(tool$schema3OtherGetConnectionApiV1SandboxGithubOauthConnectionsGet);
  tool(tool$schema3OtherConnectApiV1SandboxGithubOauthConnectionsPost);
  tool(tool$schema3OtherDisconnectApiV1SandboxGithubOauthConnectionsDelete);
  tool(tool$schema3OtherListRepositoriesApiV1SandboxGithubRepositoriesGet);
  tool(
    tool$schema3OtherRefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPost,
  );
  tool(
    tool$schema3OtherResolveReferenceApiV1SandboxGithubRepositoriesResolvePost,
  );
  tool(
    tool$schema3OtherReadCloneApiV1SandboxSessionsSessionIdGithubReadClonePost,
  );
  tool(tool$sandboxCreate);
  tool(tool$sandboxList);
  tool(tool$sandboxGet);
  tool(tool$sandboxGetPricing);
  tool(tool$sandboxSetPricing);
  tool(tool$sandboxGetBrowserUrl);
  tool(tool$sandboxProxyBrowserPortRequest);
  tool(tool$sandboxRunCommand);
  tool(tool$sandboxRunCode);
  tool(tool$sandboxTerminate);
  tool(tool$sandboxGetWorkspace);
  tool(tool$sandboxDownloadFile);
  tool(tool$sandboxUploadFile);
  tool(tool$sandboxDownloadArchive);
  tool(tool$sandboxUploadArchive);
  tool(tool$usageSandbox);
  tool(tool$usageCosts);
  tool(tool$agentsListAgents);
  tool(tool$agentsCreateAgent);
  tool(tool$agentsGetAgent);
  tool(tool$agentsUpdateAgent);
  tool(tool$agentsDeleteAgent);
  tool(tool$agentConnectorsListAgentConnectors);
  tool(tool$agentConnectorsCreateAgentConnector);
  tool(tool$agentConnectorsSetupWhatsAppAppWebhook);
  tool(tool$agentConnectorsGetAgentConnector);
  tool(tool$agentConnectorsDeleteAgentConnector);
  tool(tool$agentConnectorsActivateAgentConnector);
  tool(tool$agentVersionsListAgentVersions);
  tool(tool$agentVersionsGetAgentVersion);
  tool(tool$agentVersionsRollbackAgentVersion);
  tool(tool$agentSchedulesListAgentSchedules);
  tool(tool$agentSchedulesCreateAgentSchedule);
  tool(tool$agentSchedulesGetAgentSchedule);
  tool(tool$agentSchedulesUpdateAgentSchedule);
  tool(tool$agentSchedulesDeleteAgentSchedule);
  tool(tool$agentSchedulesPauseAgentSchedule);
  tool(tool$agentSchedulesResumeAgentSchedule);
  tool(tool$agentRunsListAgentRuns);
  tool(tool$agentRunsCreateAgentRun);
  tool(tool$agentRunsStreamAgentRunEvents);
  tool(tool$agentRunsWakeAgentRun);
  tool(tool$agentRunsDecideAgentRunMcpApproval);
  tool(tool$agentRunsGetAgentRun);
  tool(tool$budgetsList);
  tool(tool$budgetsGetOrg);
  tool(tool$budgetsSetOrg);
  tool(tool$budgetsDeleteOrg);
  tool(tool$budgetsOrgEvents);
  tool(tool$budgetsGetApiKey);
  tool(tool$budgetsSetApiKey);
  tool(tool$budgetsDeleteApiKey);
  tool(tool$budgetsApiKeyEvents);
  tool(tool$budgetsGetUser);
  tool(tool$budgetsSetUser);
  tool(tool$budgetsDeleteUser);
  tool(tool$budgetsUserEvents);
  tool(tool$budgetsGetTeam);
  tool(tool$budgetsSetTeam);
  tool(tool$budgetsDeleteTeam);
  tool(tool$budgetsTeamEvents);
  tool(tool$budgetsGetExternalUser);
  tool(tool$budgetsSetExternalUser);
  tool(tool$budgetsDeleteExternalUser);
  tool(tool$budgetsExternalUserEvents);
  tool(tool$budgetsGetUserDefault);
  tool(tool$budgetsSetUserDefault);
  tool(tool$budgetsDeleteUserDefault);
  tool(tool$budgetsUserDefaultEvents);
  tool(tool$budgetsGetTeamDefault);
  tool(tool$budgetsSetTeamDefault);
  tool(tool$budgetsDeleteTeamDefault);
  tool(tool$budgetsTeamDefaultEvents);
  tool(tool$budgetsGetExternalUserDefault);
  tool(tool$budgetsSetExternalUserDefault);
  tool(tool$budgetsDeleteExternalUserDefault);
  tool(tool$budgetsExternalUserDefaultEvents);
  tool(tool$budgetsGetCurrency);
  tool(tool$budgetsSetCurrency);
  tool(tool$computeCatalogListAccelerators);
  tool(tool$computeCatalogGetAccelerator);
  tool(tool$computeCatalogListComputeOffers);
  tool(tool$computeCatalogListComputeProviders);
  tool(tool$computeCatalogCreateComputeQuote);
  tool(tool$computeJobsListJobs);
  tool(tool$computeJobsCreateJob);
  tool(tool$computeJobsGetJob);
  tool(tool$computeJobsListJobEvents);
  tool(tool$computeJobsListJobInstances);
  tool(tool$computeJobsListJobLogs);
  tool(tool$computeJobsTerminateJob);
  tool(tool$computeSecretsListComputeSecrets);
  tool(tool$computeSecretsCreateComputeSecret);
  tool(tool$computeSecretsDeleteComputeSecret);
  tool(tool$computeSecretsGetComputeSecret);
  tool(tool$computeServicesListServices);
  tool(tool$computeServicesCreateService);
  tool(tool$computeServicesGetService);
  tool(tool$computeServicesListServiceEvents);
  tool(tool$computeServicesListServiceInstances);
  tool(tool$computeServicesListServiceLogs);
  tool(tool$computeServicesTerminateService);
  tool(tool$computeTenantsListComputeTenants);
  tool(tool$computeTenantsGetComputeTenant);
  tool(tool$computeTenantsPutComputeTenant);
  tool(tool$computeUsageGetComputeUsage);
  tool(tool$reposList);
  tool(tool$reposCreate);
  tool(tool$reposDelete);
  tool(tool$reposGet);
  tool(tool$reposUpdate);
  tool(tool$permissionsLlmGrant);
  tool(tool$permissionsLlmRevoke);
  tool(tool$permissionsLlmCheck);
  tool(tool$llmBatchesCreate);
  tool(tool$llmBatchesList);
  tool(tool$llmBatchesGet);
  tool(tool$llmBatchesCancel);
  tool(tool$llmChatCreateChat);
  tool(tool$llmChatStream);
  tool(tool$llmConversationsCreate);
  tool(tool$llmConversationsList);
  tool(tool$llmConversationsGet);
  tool(tool$llmConversationsUpdate);
  tool(tool$llmConversationsDelete);
  tool(tool$llmConversationsListItems);
  tool(tool$llmConversationsCreateItems);
  tool(tool$llmConversationsDeleteItems);
  tool(tool$llmConversationsGetItem);
  tool(tool$llmConversationsDeleteItem);
  tool(tool$llmEmbeddingsListModels);
  tool(tool$llmEmbeddingsEmbed);
  tool(tool$llmEvalsCreateSuite);
  tool(tool$llmEvalsListSuites);
  tool(tool$llmEvalsGetSuite);
  tool(tool$llmEvalsDeleteSuite);
  tool(tool$llmEvalsCreateSuiteVersion);
  tool(tool$llmEvalsListSuiteVersions);
  tool(tool$llmEvalsGetSuiteVersion);
  tool(tool$llmEvalsListSuiteLeaderboardRuns);
  tool(tool$llmEvalsCreateRun);
  tool(tool$llmEvalsListRuns);
  tool(tool$llmEvalsGetRun);
  tool(tool$llmEvalsDeleteRun);
  tool(tool$llmEvalsCancelRun);
  tool(tool$llmEvalsRerunFailedSamples);
  tool(tool$llmEvalsRetryFailedRun);
  tool(tool$llmEvalsListSamples);
  tool(tool$llmEvalsGetSampleAudio);
  tool(tool$llmEvalsGetArtifacts);
  tool(tool$llmEvalsImportHistoricalResults);
  tool(tool$llmEvalsCreateSchedule);
  tool(tool$llmEvalsListSchedules);
  tool(tool$llmEvalsGetSchedule);
  tool(tool$llmEvalsUpdateSchedule);
  tool(tool$llmEvalsDeleteSchedule);
  tool(tool$llmEvalsTriggerSchedule);
  tool(tool$llmEvalsListScheduleRuns);
  tool(tool$llmFeedbackCreateCompletionFeedback);
  tool(tool$llmFeedbackListCompletionFeedback);
  tool(tool$llmFeedbackGetCompletionFeedback);
  tool(tool$llmFeedbackUpdateCompletionFeedback);
  tool(tool$llmFeedbackBatchGetCompletionFeedback);
  tool(tool$llmFeedbackCreateResponseFeedback);
  tool(tool$llmFeedbackListResponseFeedback);
  tool(tool$llmFeedbackGetResponseFeedback);
  tool(tool$llmFeedbackUpdateResponseFeedback);
  tool(tool$llmFeedbackBatchGetResponseFeedback);
  tool(tool$llmFeedbackExportCompletionFeedback);
  tool(tool$llmFeedbackExportResponseFeedback);
  tool(tool$llmFeedbackStartExport);
  tool(tool$llmFeedbackGetExportStatus);
  tool(tool$llmFilesUpload);
  tool(tool$llmFilesList);
  tool(tool$llmFilesGet);
  tool(tool$llmFilesDelete);
  tool(tool$llmFilesContent);
  tool(tool$llmFineTuningCreate);
  tool(tool$llmFineTuningList);
  tool(tool$llmFineTuningRetrieve);
  tool(tool$llmFineTuningCancel);
  tool(tool$llmFineTuningPause);
  tool(tool$llmFineTuningResume);
  tool(tool$llmFineTuningListEvents);
  tool(tool$llmFineTuningListCheckpoints);
  tool(tool$llmImagesCreate);
  tool(tool$llmMcpVaultCreateServer);
  tool(tool$llmMcpVaultListServers);
  tool(tool$llmMcpVaultGetServer);
  tool(tool$llmMcpVaultUpdateServer);
  tool(tool$llmMcpVaultDeleteServer);
  tool(tool$llmMcpVaultCreateCredential);
  tool(tool$llmMcpVaultListCredentials);
  tool(tool$llmMcpVaultDeleteCredential);
  tool(tool$llmMcpVaultTestServer);
  tool(tool$llmMemoryStoresCreate);
  tool(tool$llmMemoryStoresList);
  tool(tool$llmMemoryStoresGet);
  tool(tool$llmMemoryStoresUpdate);
  tool(tool$llmMemoryStoresDelete);
  tool(tool$llmMemoryStoresCreateEntry);
  tool(tool$llmMemoryStoresListEntries);
  tool(tool$llmMemoryStoresGetEntry);
  tool(tool$llmMemoryStoresUpdateEntry);
  tool(tool$llmMemoryStoresDeleteEntry);
  tool(tool$llmModelsList);
  tool(tool$llmModelsGet);
  tool(tool$llmModelsListCatalog);
  tool(tool$llmModelsAddCatalogEntry);
  tool(tool$llmModelsUpdateCatalogEntry);
  tool(tool$llmModelsDeleteCatalogEntry);
  tool(tool$llmModelsCheckCatalogHealth);
  tool(tool$llmModelsListCatalogOrgAccess);
  tool(tool$llmModelsAddCatalogOrgAccess);
  tool(tool$llmModelsReplaceCatalogOrgAccess);
  tool(tool$llmModelsListCatalogModelAccess);
  tool(tool$llmModelsListRegistry);
  tool(tool$llmModelsActivateRegistryEntry);
  tool(tool$llmModelsDeactivateRegistryEntry);
  tool(tool$llmModelsListOrgAutoModels);
  tool(tool$llmModelsPutOrgAutoModel);
  tool(tool$llmModelsDeleteOrgAutoModel);
  tool(tool$llmModelsGetClusterCurrency);
  tool(tool$llmModelsSetClusterCurrency);
  tool(tool$llmModelsListClusterPrices);
  tool(tool$llmModelsSetClusterPrice);
  tool(tool$llmModelsClearClusterPrice);
  tool(tool$llmModelsListOrgPrices);
  tool(tool$llmModelsSetOrgPrice);
  tool(tool$llmModelsClearOrgPrice);
  tool(tool$llmModelsListEffectivePrices);
  tool(tool$llmPromptsCreate);
  tool(tool$llmPromptsList);
  tool(tool$llmPromptsGet);
  tool(tool$llmPromptsUpdate);
  tool(tool$llmPromptsDelete);
  tool(tool$llmPromptsCreateVersion);
  tool(tool$llmPromptsListVersions);
  tool(tool$llmPromptsGetVersion);
  tool(tool$llmPromptsRollback);
  tool(tool$llmResponsesCreate);
  tool(tool$llmResponsesList);
  tool(tool$llmResponsesGet);
  tool(tool$llmResponsesUpdate);
  tool(tool$llmResponsesDelete);
  tool(tool$llmResponsesCancel);
  tool(tool$llmResponsesWake);
  tool(tool$llmResponsesListInputItems);
  tool(tool$llmResponsesCompact);
  tool(tool$llmSpeechTranscribe);
  tool(tool$llmSpeechSpeak);
  tool(tool$llmSpeechSpeakStreaming);
  tool(tool$llmSpeechLivekitToken);
  tool(tool$llmSpeechListTtsHistory);
  tool(tool$llmSpeechGetTtsHistory);
  tool(tool$llmSpeechDeleteTtsHistory);
  tool(tool$llmSpeechGetTtsHistoryContent);
  tool(tool$llmSpeechListTranscriptionHistory);
  tool(tool$llmSpeechGetTranscriptionHistory);
  tool(tool$llmSpeechDeleteTranscriptionHistory);
  tool(tool$llmSpeechGetTranscriptionHistoryContent);
  tool(tool$llmUsageCompletions);
  tool(tool$llmUsageResponses);
  tool(tool$llmUsageConversations);
  tool(tool$llmUsageEmbeddings);
  tool(tool$llmUsageExtract);
  tool(tool$llmUsageClassify);
  tool(tool$llmUsageVectorStores);
  tool(tool$llmUsageFiles);
  tool(tool$llmUsageCosts);
  tool(tool$llmClassifyClassify);
  tool(tool$llmExtractExtract);
  tool(tool$llmExtractCreateSchema);
  tool(tool$llmExtractGetSchema);
  tool(tool$llmExtractUpdateSchema);
  tool(tool$llmExtractDeleteSchema);
  tool(tool$llmExtractExtractWithSchema);
  tool(tool$llmSkillsCreate);
  tool(tool$llmSkillsList);
  tool(tool$llmSkillsGet);
  tool(tool$llmSkillsUpdate);
  tool(tool$llmSkillsDelete);
  tool(tool$llmSkillsContent);
  tool(tool$llmSkillsCreateVersion);
  tool(tool$llmSkillsListVersions);
  tool(tool$llmSkillsGetVersion);
  tool(tool$llmSkillsDeleteVersion);
  tool(tool$llmSkillsVersionContent);
  tool(tool$llmSkillsListPreconfigured);
  tool(tool$llmVectorStoresCreate);
  tool(tool$llmVectorStoresList);
  tool(tool$llmVectorStoresGet);
  tool(tool$llmVectorStoresUpdate);
  tool(tool$llmVectorStoresDelete);
  tool(tool$llmVectorStoresSearch);
  tool(tool$llmVectorStoresCreateFile);
  tool(tool$llmVectorStoresListFiles);
  tool(tool$llmVectorStoresGetFile);
  tool(tool$llmVectorStoresUpdateFile);
  tool(tool$llmVectorStoresDeleteFile);
  tool(tool$llmVectorStoresGetFileContent);
  tool(tool$llmVectorStoresCreateFileBatch);
  tool(tool$llmVectorStoresGetFileBatch);
  tool(tool$llmVectorStoresCancelFileBatch);
  tool(tool$llmVectorStoresListFilesInBatch);
  tool(tool$authApiKeysCreate);
  tool(tool$authApiKeysList);
  tool(tool$authApiKeysUpdate);
  tool(tool$authApiKeysRegenerate);
  tool(tool$authApiKeysExchangeToken);
  tool(tool$authTeamsCreate);
  tool(tool$authTeamsList);
  tool(tool$authTeamsGet);
  tool(tool$authTeamsUpdate);
  tool(tool$authTeamsDelete);
  tool(tool$authTeamsAddMember);
  tool(tool$authTeamsListMembers);
  tool(tool$authTeamsRemoveMember);
  tool(tool$authServiceAccountsCreate);
  tool(tool$authServiceAccountsList);
  tool(tool$authServiceAccountsGet);
  tool(tool$authServiceAccountsDelete);
  tool(tool$authServiceAccountsListApiKeys);
  tool(tool$authServiceAccountsUpdateApiKey);
  tool(tool$authServiceAccountsDeleteApiKey);
  tool(tool$authServiceAccountsRegenerateApiKey);
  tool(tool$authOrgsGetQuota);
  tool(tool$authOrgsUpdateQuota);
  tool(tool$authOrgsGetRateLimit);
  tool(tool$authOrgsUpdateRateLimit);
  tool(tool$authClusterCreateInvite);
  tool(tool$authClusterListInvites);
  tool(tool$authClusterRevokeInvite);
  tool(tool$authClusterListOrgs);
  tool(tool$authClusterGetOrg);
  tool(tool$authClusterDeleteOrg);
  tool(tool$authClusterSuspendOrg);
  tool(tool$authClusterUnsuspendOrg);
  tool(tool$authClusterReissueOwnerKey);
  tool(tool$authClusterInviteInfo);
  tool(tool$authClusterAcceptInvite);
  tool(tool$authApiKeyGetJwtFromKey);

  return server;
}
